var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVisibilityEye = function SvgVisibilityEye(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 0C4.5 0 1.2975 2.3325 0 5.625C1.2975 8.9175 4.5 11.25 8.25 11.25C12 11.25 15.2025 8.9175 16.5 5.625C15.2025 2.3325 12 0 8.25 0ZM8.25 9.375C6.18 9.375 4.5 7.695 4.5 5.625C4.5 3.555 6.18 1.875 8.25 1.875C10.32 1.875 12 3.555 12 5.625C12 7.695 10.32 9.375 8.25 9.375ZM8.25 3.375C7.005 3.375 6 4.38 6 5.625C6 6.87 7.005 7.875 8.25 7.875C9.495 7.875 10.5 6.87 10.5 5.625C10.5 4.38 9.495 3.375 8.25 3.375Z",
    fill: "#313336"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVisibilityEye);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "visibility-eye.cedb0e97a160925a2d22583ca9e3c4ca.svg";